import { SET_FILTROS_COLUNAS_PLANEJAMENTO } from '../actions/actionTypes';

const initialState = {
    colunas: [
        {
            label: 'Checkbox',
            dataKey: 'checkbox',
            show: true,
            hideMenu: true,
        },
        {
            label: 'Material',
            dataKey: 'material',
            show: true,
        },
        {
            label: 'Cor',
            dataKey: 'cor',
            show: true,
        },
        {
            label: 'Descrição',
            dataKey: 'descricao',
            show: true,
        },
        {
            label: 'Espécie',
            dataKey: 'especie',
            show: true,
        },
        {
            label: 'Espécie\nDet',
            dataKey: 'especieDetalhada',
            show: true,
        },
        {
            label: 'Est.',
            dataKey: 'estacao',
            show: true,
        },
        {
            label: 'Col.',
            dataKey: 'colecao',
            show: true,
        },
        {
            label: 'Marca',
            dataKey: 'marca',
            show: true,
        },
        {
            label: 'Saldo+',
            dataKey: 'saldoPositivo',
            show: true,
        },
        {
            label: 'Saldo-',
            dataKey: 'saldoNegativo',
            show: true,
        },
        {
            label: 'Dt.Remessa',
            dataKey: 'data',
            show: true,
        },
        {
            label: 'P.V',
            dataKey: 'pv',
            show: true,
        },
        {
            label: 'Lote mín.',
            dataKey: 'loteMinimo',
            show: true,
        },
        {
            label: 'Venda Descoberta',
            dataKey: 'vendaDescoberta',
            show: true,
        },
        {
            label: 'Est.Ini.\n(+)',
            dataKey: 'estoqueInicial',
            show: true,
        },
        {
            label: 'WIP\n(+)',
            dataKey: 'qtdEstoqueProdPed',
            show: true,
        },
        {
            label: 'Licença',
            dataKey: 'licenca',
            show: true,
        },
        {
            label: 'Cliente',
            dataKey: 'cliente',
            show: true,
        },
        {
            label: 'Cliente especial',
            dataKey: 'clienteEspecial',
            show: true,
        },
        {
            label: 'G. Produto',
            dataKey: 'grupoDeProduto',
            show: true,
        },
        {
            label: 'Qtd.Pçs Prog. Manual',
            dataKey: 'qtdProgramadaManual',
            show: true,
        },
        {
            label: 'Wip Futuro',
            dataKey: 'qtdWipFuturo',
            show: true,
        },
        {
            label: 'Alt.Man.',
            dataKey: 'alteradoManual',
            show: true,
        },
        {
            label: 'Qtd.Pçs\n(+)',
            dataKey: 'qtdProgramada',
            show: true,
        },
        {
            label: 'Qtd.Pçs\n SAP',
            dataKey: 'qtdProgramadaSAP',
            show: true,
        },
        {
            label: '% Ante.',
            dataKey: 'percAnt',
            show: true,
        },
        {
            label: '% Ante. Venda Futura',
            dataKey: 'percAntVendaFutura',
            show: true,
        },
        {
            label: '% Est.Seg.',
            dataKey: 'percEstoqueSeg',
            show: true,
        },
        {
            label: 'Fábrica',
            dataKey: 'cdFabrica',
            show: true,
        },
        {
            label: 'CT/ZCOS',
            show: true,
            dataKey: 'ctZcos',
        },
        {
            label: 'Est.Seg.\n(-)',
            dataKey: 'estoqueSeguranca',
            show: true,
        },
        {
            label: 'Falta PE',
            dataKey: 'qtdFaltaEstoqueSeguranca',
            show: true,
        },
        {
            label: 'Faixa Operacional',
            dataKey: 'faixaOperacional',
            show: true,
        },
        {
            label: 'Programação PE',
            dataKey: 'qtdPecasEstoqueSeguranca',
            show: true,
        },
        {
            label: 'Saldo descasado',
            dataKey: 'saldoDescasado',
            show: true,
        },
        {
            label: 'Qnt.Prog.S.M',
            dataKey: 'qtdProgSemMulti',
            show: true,
        },
        {
            label: '%Ante.S.M',
            dataKey: 'percAntSemMulti',
            show: true,
        },
        {
            label: 'Qnt.Prog.M.I',
            dataKey: 'qtdProgSemIgua',
            show: true,
        },
        {
            label: '%Ante.M.I',
            dataKey: 'percAntSemIgua',
            show: true,
        },
        {
            label: 'Nó',
            dataKey: 'no',
            show: true,
        },
        {
            label: 'Qtd.Alocada',
            dataKey: 'qtdAlocada',
            show: true,
        },
        {
            label: 'Venda R.\n(-)',
            dataKey: 'qtdVenda',
            show: true,
        },
        {
            label: 'Venda T.',
            dataKey: 'qtdVendaTotal',
            show: true,
        },
        {
            label: 'Prev.\n(-)',
            dataKey: 'qtdPrevisao',
            show: true,
        },
        {
            label: 'Prev. T.\n(-)',
            dataKey: 'qtdPrevisaoTotal',
            show: true,
        },
        {
            label: 'RA-2ª Qual\n(-)',
            dataKey: 'qtdSegundaQualidade',
            show: true,
        },
        {
            label: 'Guardar\n(-)',
            dataKey: 'guardar',
            show: true,
        },
        {
            label: 'Sobra Guardar',
            dataKey: 'guardarCalculado',
            show: true,
        },
        {
            label: 'Múltiplo\n(-)',
            dataKey: 'multiplo',
            show: true,
        },
        {
            label: 'Nec.',
            dataKey: 'necessidadeCalculada',
            show: true,
        },
        {
            label: 'Nec.Mul.',
            dataKey: 'necessidadeMultiplo',
            show: true,
        },
        {
            label: 'Nec.Ant.',
            dataKey: 'qtdNecAntecipada',
            show: true,
        },
        {
            label: 'Saldo Qtd. Ant.',
            dataKey: 'saldoQtdAnt',
            show: true,
        },
        {
            label: 'Est. Final\n(=)',
            dataKey: 'estoqueFinal',
            show: true,
        },
        {
            label: 'Est.Final\nFechamento',
            dataKey: 'estoqueFinalFechamento',
            show: true,
        },
        {
            label: 'Saldo Cober.\n(=)',
            dataKey: 'saldoCobertura',
            show: true,
        },
        {
            label: 'Gastar',
            dataKey: 'qtdGastar',
            show: true,
        },
        {
            label: 'Cob.Est.(%)\n(=)',
            dataKey: 'coberturaEstoque',
            show: true,
        },
        {
            label: 'Tempo',
            dataKey: 'tempo',
            show: true,
        },
        {
            label: 'Tempo Total',
            dataKey: 'totalMinutos',
            show: true,
        },
        {
            label: 'Tempo T.Prep.',
            dataKey: 'tempoTotalPreparacao',
            show: true,
        },
        {
            label: 'Fáb. Prep',
            dataKey: 'cdFabricaPrep',
            show: true,
        },
        {
            label: 'Nivel Risco',
            dataKey: 'nivelRisco',
            show: true,
        },
        {
            label: 'Aplicação MI',
            dataKey: 'aplicouMI',
            show: true,
        },
        {
            label: 'Observação',
            dataKey: 'observacao',
            show: true,
        },
        {
            label: 'NP',
            dataKey: 'naoPrograma',
            show: true,
        },
        {
            label: 'Justificativa NP',
            dataKey: 'justificativaNP',
            show: true,
        },
    ],
};

export const filterColunasPlanejamento = (state = initialState, action) => {
    switch (action.type) {
        case SET_FILTROS_COLUNAS_PLANEJAMENTO:
            const newState = {
                colunas: Object.assign([], state.colunas),
            };
            let coluna = newState.colunas.find((x) => x.dataKey === action.payload.dataKey);
            coluna.show = !coluna.show;
            return newState;
        default:
            return state;
    }
};
